import React from "react";

import { Typography } from "clearsense-ui/components";

import AggregateRow from "./AggregateRow";
import HeaderRow from "./HeaderRow";
import PredictedNegativesRow from "./PredictedNegativesRow";
import PredictedPositivesRow from "./PredictedPositivesRow";

const ConfusionMatrix = ({ data }) => (
  <>
    <Typography
      style="h3"
      type="semibold"
      className="flex-none px-6 py-4 border-b-2"
    >
      Confusion Matrix
    </Typography>
    <div className="p-6 overflow-auto">
      {data ? (
        <table className="w-full">
          <thead className="w-full">
            <HeaderRow />
          </thead>

          <tbody className="bg-gray-100 border-gray-300">
            <PredictedPositivesRow positives={data.positives} />
            <PredictedNegativesRow negatives={data.negatives} />
            <AggregateRow
              positives={data.positives}
              negatives={data.negatives}
            />
          </tbody>
        </table>
      ) : (
        <div className="min-h-[250px] flex justify-center items-center">
          <Typography>Failed to Load data</Typography>
        </div>
      )}
    </div>
  </>
);

export default ConfusionMatrix;
